module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmIyNWRhZTQwY2VmODc5ZjQ3MjM4YzI0MmFmYzVkN2MucG5nIjs="